//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("communicationTemplate", CommunicationTemplateFactory);

    CommunicationTemplateFactory.$inject = ["apiClientFactory"];
    function CommunicationTemplateFactory(apiClientFactory) {

        const routePrefix = "api/communication-templates/";

        return {
            ExportAll: apiClientFactory.get(routePrefix + "export/"),
            Get: apiClientFactory.get(routePrefix),
            Load: apiClientFactory.get(routePrefix),
            Save: apiClientFactory.put(routePrefix),
        };
    }
})();
